import { TableCell, TableHead, TableRow } from '@mui/material'

export default function StudySeriesTableHeader() {
  return (
    <TableHead
      sx={{
        bgcolor: 'paper.main',
      }}
    >
      <TableRow>
        <TableCell>Series description</TableCell>
        <TableCell>Series №</TableCell>
        <TableCell>Acquisition date</TableCell>
        <TableCell>Instances</TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  )
}
